import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL, HTTP_STATUS } from '../../utils/constant'
import { newAxiosInstance } from '../../../axios'
import UrlBuilder from 'app/utils/UrlBuilder'
import { generateDownloadFileName, downloadFile } from 'app/utils/utils';

const initialState = {
    attendanceReport: null,
    status: HTTP_STATUS.IDLE,
}

export const fetchAttendanceReport = createAsyncThunk('attendanceReport/fetch', async (data = null, { rejectWithValue }) => {
    try {
        let url = new UrlBuilder().filter(data, 'fileType').filter(data, 'month').filter(data, 'year').getUrl();
        let responseType = data?.fileType && parseInt(data.fileType) > 0 ? 'blob' : 'text';
        const response = await newAxiosInstance.get(BASE_URL + `/api/Attendance/monthly-report${url}`, { responseType });
        if (responseType === 'text') return response.data;
        let filename = generateDownloadFileName(response.headers['content-disposition']);
        downloadFile(response.data, filename);
        return null;
    } catch (err) {
        if (!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const AttendanceReport = createSlice({
    name: 'attendanceReport',
    initialState,
    reducers: {
        resetState: () => initialState,
    },
    extraReducers(builder) {
        builder
            .addCase(fetchAttendanceReport.pending, (state) => {
                state.status = HTTP_STATUS.LOADING
            })
            .addCase(fetchAttendanceReport.fulfilled, (state, action) => {
                state.status = HTTP_STATUS.SUCCEEDED
                state.attendanceReport = action.payload
            })
            .addCase(fetchAttendanceReport.rejected, (state) => {
                state.status = HTTP_STATUS.FAILED
            })
    }
})

export const getAttendanceReport = (state) => state.attendanceReport.attendanceReport;
export const getAttendanceReportStatus = (state) => state.attendanceReport.status;
export const AttendanceReportActions = AttendanceReport.actions

export default AttendanceReport.reducer
